export default "__VITE_ASSET__CvrV9$Nj__"